import { useNavigate } from 'react-router-dom'

import { Badge, Text, Button } from '@/ui'
import { TypographyStyles } from '@/styles'
import { useTherapistFlag, CaseStyle } from '@/utils/launchdarklyHelpers'

//todo ZEN-2164 there's should be a video here but it's not ready
export const IncomePlanningIntro = ({ onClose }: { onClose: () => void }) => {
  const navigate = useNavigate()
  const replacementText = useTherapistFlag(CaseStyle.lowerCase, false)

  return (
    <>
      <Text variant={TypographyStyles.DISPLAY_XS}>Income Planning</Text>

      <div className="mt-10 md:px-10 lg:px-10">
        <Text variant={TypographyStyles.H1}>Understanding income planning</Text>
        <Text variant={TypographyStyles.BODY_SM}>
          Setting annual goals gives you a target to aspire to. Our income
          planning tool can help you get make plans on a monthly basis to get to
          that goal.
        </Text>

        <div className="flex items-start gap-4 mt-6">
          <Badge color="olive" size="md" variant="secondary">
            <Text variant={TypographyStyles.BODY_LG}>1</Text>
          </Badge>
          <div>
            <Text variant={TypographyStyles.LABEL_MD}>Create a plan</Text>
            <Text variant={TypographyStyles.BODY_SM} className="mt-2">
              Plans have a built-in calculator that can help you plan for
              multiple income streams. Create plans for the different scenarios
              that your practice encounters whether that’s busy months, summer
              months or holidays.
            </Text>
          </div>
        </div>

        <div className="flex items-start gap-4 mt-4">
          <Badge color="olive" size="md" variant="secondary">
            <Text variant={TypographyStyles.BODY_LG}>2</Text>
          </Badge>
          <div>
            <Text variant={TypographyStyles.LABEL_MD}>
              Make updates quickly
            </Text>
            <Text variant={TypographyStyles.BODY_SM} className="mt-2">
              We know that being a {replacementText} means that income varies
              from month to month. You’ll be able to make quick changes across
              months where you expect similar results.
            </Text>
          </div>
        </div>

        <div className="flex items-start gap-4 mt-4">
          <Badge color="olive" size="md" variant="secondary">
            <Text variant={TypographyStyles.BODY_LG}>3</Text>
          </Badge>
          <div>
            <Text variant={TypographyStyles.LABEL_MD}>
              Track against benchmarks
            </Text>
            <Text variant={TypographyStyles.BODY_SM} className="mt-2">
              Analyze how you’re performing against your plans with comparisons
              to prior year income (if available), and how you actually
              performed for the month.
            </Text>
          </div>
        </div>

        <div className="mt-8">
          <Button
            onClick={() => {
              onClose()
              navigate('/income-planning/create-plan')
            }}
          >
            Get Started
          </Button>
        </div>
      </div>
    </>
  )
}
